import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type CheckIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const CheckIcon = ({
  width = 26,
  height = 19,
  color = tokens.colors.global.white,
  ...props
}: CheckIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25.8967 18.8156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.2782 1.61855L8.69968 17.197L1.61855 10.1159"
        stroke={color}
        strokeWidth={3.23709}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
